"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentSnapshotNotificationSchema = void 0;
exports.ContentSnapshotNotificationSchema = {
    "$id": "https://www.redbull.com/schemas/snapshot-notifications/content.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ContentSnapshotNotification",
    "description": "Snapshot event with current state of entity",
    "type": "object",
    "properties": {
        "data": {
            "description": "The data field contains snapshot of content resource. For details, see https://api.developers.redbull.com/docs/snapshot-notifications",
            "type": "object",
            "oneOf": [
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/type-groups/content.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/type-groups/master.schema.json"
                }
            ]
        },
        "meta": {
            "description": "The meta field contains the snapshot event meta data. For details, see https://api.developers.redbull.com/docs/snapshot-notifications",
            "type": "object",
            "properties": {
                "contentManagementVersion": {
                    "description": "The contentManagementVersion field contains the version of the content management system that has sent the snapshot event.",
                    "type": "string"
                },
                "project": {
                    "description": "The project (destination) which this snapshot is addressed for. Enable consumers to filter out events not addresse to them to reduce load on the system.",
                    "type": "string"
                },
                "eventType": {
                    "const": "snapshot-notification:content"
                }
            },
            "additionalProperties": false
        }
    },
    "additionalProperties": false,
    "required": [
        "data",
        "meta"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGVudC5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbW9kdWxlcy9zbmFwc2hvdC1ub3RpZmljYXRpb25zL2NvbnRlbnQuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsaUNBQWlDLEdBQUc7SUFDL0MsS0FBSyxFQUFFLDRFQUE0RTtJQUNuRixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSw2QkFBNkI7SUFDdEMsYUFBYSxFQUFFLDZDQUE2QztJQUM1RCxNQUFNLEVBQUUsUUFBUTtJQUNoQixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixhQUFhLEVBQUUsdUlBQXVJO1lBQ3RKLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE9BQU8sRUFBRTtnQkFDUDtvQkFDRSxNQUFNLEVBQUUsUUFBUTtvQkFDaEIsTUFBTSxFQUFFLGlFQUFpRTtpQkFDMUU7Z0JBQ0Q7b0JBQ0UsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLE1BQU0sRUFBRSxnRUFBZ0U7aUJBQ3pFO2FBQ0Y7U0FDRjtRQUNELE1BQU0sRUFBRTtZQUNOLGFBQWEsRUFBRSx1SUFBdUk7WUFDdEosTUFBTSxFQUFFLFFBQVE7WUFDaEIsWUFBWSxFQUFFO2dCQUNaLDBCQUEwQixFQUFFO29CQUMxQixhQUFhLEVBQUUsNEhBQTRIO29CQUMzSSxNQUFNLEVBQUUsUUFBUTtpQkFDakI7Z0JBQ0QsU0FBUyxFQUFFO29CQUNULGFBQWEsRUFBRSwwSkFBMEo7b0JBQ3pLLE1BQU0sRUFBRSxRQUFRO2lCQUNqQjtnQkFDRCxXQUFXLEVBQUU7b0JBQ1gsT0FBTyxFQUFFLCtCQUErQjtpQkFDekM7YUFDRjtZQUNELHNCQUFzQixFQUFFLEtBQUs7U0FDOUI7S0FDRjtJQUNELHNCQUFzQixFQUFFLEtBQUs7SUFDN0IsVUFBVSxFQUFFO1FBQ1YsTUFBTTtRQUNOLE1BQU07S0FDUDtDQUNGLENBQUEifQ==